window.LocationsMarquee = () => ({
    observer: null,

    /* Held state for the pause toggle. */
    paused: false,

    init() {
        const measure = () => this.measure();

        this.$nextTick(measure);

        // The webfont swapping in changes the track's width.
        if (document.fonts) {
            document.fonts.ready.then(measure);
        }

        /* Resize */
        if (window.ResizeObserver) {
            this.observer = new ResizeObserver(measure);
            if (this.$refs.track) this.observer.observe(this.$refs.track);
            if (this.$refs.viewport) this.observer.observe(this.$refs.viewport);
        }
    },

    destroy() {
        this.observer?.disconnect();
    },

    measure() {
        const track = this.$refs.track;
        const viewport = this.$refs.viewport;
        if (!track || !viewport) return;

        /* `offsetWidth`, not getBoundingClientRect() — the latter reports the
           TRANSFORMED box, and this element is mid-animation. */
        const width = track.offsetWidth;
        if (width <= 0) return;

        const speed = parseFloat(
            getComputedStyle(this.$el).getPropertyValue('--marquee-speed')
        ) || 60;

        this.$el.style.setProperty('--marquee-duration', (width / speed).toFixed(2) + 's');

        this.fill(track, viewport, width);
    },

    /**
     * Keep enough copies on screen that the strip still reaches the right-hand
     * edge at the instant the loop resets.
     *
     */
    fill(track, viewport, width) {
        const needed = Math.ceil(viewport.offsetWidth / width) + 1;
        const clones = () => viewport.querySelectorAll('.locations-marquee__track--clone');

        while (clones().length + 1 < needed) {
            const copy = track.cloneNode(true);
            copy.removeAttribute('x-ref');
            copy.setAttribute('aria-hidden', 'true');
            copy.classList.add('locations-marquee__track--clone');
            viewport.appendChild(copy);
        }

        // Shed copies again if the viewport shrinks, keeping at least one.
        let extra = clones();
        while (extra.length + 1 > needed && extra.length > 1) {
            extra[extra.length - 1].remove();
            extra = clones();
        }
    },
});
